export default __webpack_public_path__ + "static/media/banner.83a1fde9.png";